import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseDrawerComponent } from '@fuse/components/drawer';
import { LayoutComponent } from 'app/layout/layout.component';
import { EmptyLayoutModule } from 'app/layout/layouts/empty/empty.module';

import { ClassicLayoutModule } from 'app/layout/layouts/vertical/classic/classic.module';
import { ClassyLayoutModule } from 'app/layout/layouts/vertical/classy/classy.module';

import { SettingsModule } from 'app/layout/common/settings/settings.module';
import { SharedModule } from 'app/shared/shared.module';

import { TranslateModule } from '@ngx-translate/core';
import { CompactLayoutModule } from './layouts/vertical/compact/compact.module';
import { ModernLayoutModule } from './layouts/horizontal/modern/modern.module';

const layoutModules = [
    // Empty
    EmptyLayoutModule,

    ClassicLayoutModule,
    ClassyLayoutModule,

    ModernLayoutModule,
    CompactLayoutModule,

];

@NgModule({
    declarations: [
        LayoutComponent
    ],
    imports: [

        TranslateModule.forChild(),
        MatIconModule,
        MatTooltipModule,
        FuseDrawerComponent,
        SharedModule,
        SettingsModule,
        ...layoutModules,
    ],
    exports     : [
        LayoutComponent,
        ...layoutModules
    ]
})
export class LayoutModule
{
}
